import { render, staticRenderFns } from "./FormFieldSet.vue?vue&type=template&id=153e4cec&scoped=true&"
import script from "./FormFieldSet.vue?vue&type=script&lang=js&"
export * from "./FormFieldSet.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldSet.vue?vue&type=style&index=0&id=153e4cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e4cec",
  null
  
)

export default component.exports